export default {
  KMS: 'kms',
  AUTH: 'auth',
  REPORT: 'report',
  TEMPLATE: 'template',
  STAMPING: 'stamping',
  DEAL_COLLAB: 'deal_collab',
  NOTIFICATION: 'notification',
  DIS: 'document-infrastructure',
  WORKFLOW_RUNNER: 'workflow-runner',
  WORKFLOW_MANAGER: 'workflow-manager',
  NOTIFICATION_CONFIG: 'notification-config',
  // The four services behind the automation module, served by
  // @leegality/sequence-automation.
  RULE_ENGINE: 'rule-engine',
  EVENT_SERVICE: 'event-service',
  SEQUENCE_MANAGER: 'sequence-manager',
  ACTIVITY_LOGGING_WORKER: 'activity-logging-worker',
  LEE_AI: 'leeai',
};
